module.exports = __webpack_public_path__ + "img/profile-2user@2x.53c694f3.png";